import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var SavePairAssignmentsCommandClass;
function SavePairAssignmentsCommand() {
  if (SavePairAssignmentsCommandClass === VOID) {
    class $ {
      constructor(partyId, pairAssignments) {
        this.i2l_1 = partyId;
        this.j2l_1 = pairAssignments;
      }
      toString() {
        return 'SavePairAssignmentsCommand(partyId=' + this.i2l_1.toString() + ', pairAssignments=' + this.j2l_1.toString() + ')';
      }
      hashCode() {
        var result = this.i2l_1.hashCode();
        result = imul(result, 31) + this.j2l_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePairAssignmentsCommand()))
          return false;
        if (!this.i2l_1.equals(other.i2l_1))
          return false;
        if (!this.j2l_1.equals(other.j2l_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePairAssignmentsCommand');
    SavePairAssignmentsCommandClass = $;
  }
  return SavePairAssignmentsCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatchernmy2not8m2c7,
  SavePairAssignmentsCommand as SavePairAssignmentsCommand20j9zexwuuh9o,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsCommand.mjs.map
